<template>
  <div class="comp-main-file" @mouseenter="setPasteY" @mouseleave="setPasteN">
    <el-dropdown class="flex flex-1" size="mini">
      <!-- 下拉必须用一个元素包住，否则会报错 -->
      <div class="flex flex-1">
        <el-upload
          ref="refUpload"
          :limit="limit"
          action="#"
          accept="all"
          class="upload-box"
          :title="$constant.uploadFilePrompt(limit, fileSize, filePrompt)"
          :multiple="limit > 1"
          :file-list="selfList.length ? selfList.slice(0, limit) : []"
          :http-request="fileUpload"
          :on-remove="fileDelete"
          :on-exceed="fileExceed"
          :before-upload="beforeAvatarUpload"
        >
          <!-- 点击上传 真按键 -->
          <div v-if="!selfDisabled" slot="default" class="file-add" size="mini" plain>
            <span>点击上传</span>
            <span v-if="selfList.length">({{ selfList.length }})</span>
          </div>
          <!-- 点击上传 假按键 -->
          <div slot="tip" class="file-look" size="mini" plain>
            <span v-if="!selfDisabled">点击上传</span>
            <span v-if="selfDisabled && selfList.length">已经上传</span>
            <span v-if="selfList.length">({{ selfList.length }})</span>
          </div>
        </el-upload>
      </div>
      <!-- 已上传列表 -->
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in selfList"
          :key="index"
          @click.native="fileDownload(item)"
        >
          <span class="file-name ellipsis">
            {{ item.name }}
          </span>
          <span
            v-if="selfDelete"
            class="file-delete el-icon-delete"
            title="删除"
            @click="fileDelete(item)"
          />
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    fileSize: {
      type: Number,
      default: 10 // MB
    },
    filePrompt: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfList: [],
      isPaste: false
    }
  },
  computed: {
    selfDisabled() {
      return this.selfList.length >= this.limit || this.disabled
    },
    selfDelete() {
      return this.isDelete && !this.disabled
    }
  },
  watch: {
    list: {
      handler(val) {
        if (JSON.stringify(this.selfList) !== JSON.stringify(val)) {
          this.selfList = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    selfList: {
      handler(val) {
        if (JSON.stringify(this.list) !== JSON.stringify(val)) {
          this.$emit('update:list', val)
        }
      },
      deep: true
    }
  },
  mounted() {
    // 监听全局粘贴事件
    document.addEventListener('paste', this.filePaste)
  },
  beforeDestroy() {
    // 销毁时移除监听
    document.removeEventListener('paste', this.filePaste)
  },
  methods: {
    setPasteY() {
      this.isPaste = true
    },
    setPasteN() {
      this.isPaste = false
    },
    // 处理粘贴事件
    filePaste(event) {
      if (!this.isPaste) return
      if (this.selfDisabled) return
      let items = event.clipboardData?.items
      if (!items) return
      // 遍历剪贴板中的内容，找到文件
      let imgArr = []
      for (let item of items) {
        imgArr.push(item)
      }
      // 可拷贝最大数
      let pasteMax = this.limit - this.selfList.length
      if (pasteMax > 0) {
        imgArr.forEach((item, index) => {
          if (index < pasteMax) {
            let blob = item.getAsFile()
            if (blob) {
              let file = new File([blob], 'screenshot.png', { type: blob.type }) // 将 Blob 转换为 File 对象
              this.fileUpload({ file }) // 手动触发 el-upload 上传
            }
          }
        })
      }
    },
    // 文件上传
    fileUpload(option) {
      let data = new FormData()
      let file = option.file
      data.append('file', file)
      data.append('uid', file.uid)
      this.$api({
        method: 'post',
        url: '/admin/upload/imgCommon',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.selfList.push(res.data.img)
            this.$message.success('上传文件成功!')
          } else {
            this.fileDelete(file) // 上传失败，直接移除
          }
        })
        .catch(() => {
          this.fileDelete(file) // 上传失败，直接移除
        })
    },
    // 文件删除
    fileDelete(file) {
      let index = this.selfList.findIndex((item) => item.id === file.id)
      this.selfList.splice(index, 1)
      this.$api({
        method: 'post',
        url: '/admin/upload/deleteImg',
        data: {
          url: file.url,
          uid: file.uid
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          // this.$message.success('文件删除成功！')
        } else {
          this.$message.error('文件删除失败！')
        }
      })
    },
    // 文件超出限制
    fileExceed() {
      this.$message.error(`最多上传${this.limit}个文件！`)
    },
    // 上传前限制
    beforeAvatarUpload(file) {
      const isPassFileSize = file.size / 1024 / 1024 < this.fileSize
      if (!isPassFileSize) this.$message.error(`文件大小不能超过${this.fileSize}MB!`)

      return isPassFileSize
    },
    // 文件下载
    fileDownload(file) {
      window.open(file.url, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main-file {
  height: 26px;
  font-size: 12px;
  border-radius: 4px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  position: relative;
  /deep/ .el-upload {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // z-index: 999;
  }
  /deep/ .el-upload-list {
    display: none;
  }
  .upload-box {
    display: flex;
    flex: 1;
    .file-look {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      line-height: 26px;
      color: @colorGrayLight;
      background: @colorGrayF;
      border-radius: 4px;
    }
    .file-add {
      line-height: 26px;
      color: @colorGrayLight;
      background: @colorWhite;
      border-radius: 4px;
      &:hover,
      &:focus {
        color: @colorBlue;
        background: #ecf5ff;
      }
    }
  }
}
</style>
